import Button from "@mui/material/Button";

interface Props {
  children: React.ReactNode;
  callback: React.MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
  testId: string;
}

const ImpersonationButton = ({
  callback,
  children,
  disabled = false,
  testId,
}: Props) => (
  <Button
    data-testid={testId}
    disabled={disabled}
    onClick={(evt) => callback(evt)}
  >
    {children}
  </Button>
);

export { ImpersonationButton };
